"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _TransmuteCollection = require("./TransmuteCollection");

_TransmuteCollection.has.implement(Array, function (key, arr) {
  return arr.hasOwnProperty(key);
});

_TransmuteCollection.has.implementInherited(_immutable.Iterable, function (key, subject) {
  return subject.has(key);
});

_TransmuteCollection.has.implement(Object, function (key, obj) {
  return obj.hasOwnProperty(key);
});

var _default = _TransmuteCollection.has;
exports.default = _default;
module.exports = exports.default;